module.exports = __webpack_public_path__ + "img/pexels-pixabay-50711.f2a5f419.jpg";